import{getDefaultExportFromCjs as e}from"./_commonjsHelpers.js";import{__require as o}from"../node_modules/prop-types/index.js";var r=o(),s=e(r);export{s as default,r as p};
//# sourceMappingURL=index3.js.map
